import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
import styles from "../../../../services/ServicesSections.module.scss";
// core components





export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section} id = "start">
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={10} md={10}>

        <h2 className={classes.title}>WARNING FAKE FACEBOOK ADS!</h2>
            <p>Over the last 3 months we have had a slow steady increase in people following up on erroneous job posts on facebook local community groups in the Australia/Melbourne/Victoria area - from people claiming to represent our company.</p>
            <p>See below for an example.</p>

            

              <div style={{textAlign: "center",maxWidth:"1000px",width:"100%"}}>
            <GridItem xs={25} sm={25} md={25}>     
                  <img
                    src="/img/posts/2025-02-04-facebook-scams/Fake-Facebook-Ad.png"
                    alt="Building a Streamlit application in 5 steps."
                    className={imgClasses}
                  />
                  <p><br></br><i></i></p>
            </GridItem>
            </div>

            <p>What the lay person needs to understand is that it is incredibly difficult for us to or any other company/individual to find or do anything about it. The above was hidden in a local community group - we had to ask and wait for approval for access to it. </p>
            <p>Our company address and of course name is freely available on our website and other sources. We can only assume relevant victim wesbites a like ours have been scanned and details copied. </p>
            <p>These groups have rules against marketing and shady fraudulent practices. When we went to look for these posts after finally being approved (we have to be fraudulent ourselves just to get access to the group!) the posts are gone. Maybe removed by the Admins. Maybe the admins are part of it? </p> <p>All of it is unknown and facebook is wholly unwilling and unprepared to do anything about it. </p>


          <h3 className={classes.title} id="summary">What is facebook doing about it?</h3>

            <p> Nothing...  </p>

            <p> To clarify...</p> 
            <p> ...facebook *does* have a "process" where you can report fraudulant profiles and pages (< a href="https://www.facebook.com/help/1008249932604232">by filling out these forms.</a>). Typical big tech strategy where speaking to an actual person, having any nuance to your situation  or even getting a response - is ignored or avoided.</p>
            
            <p>Reddit posts such as these <a href="https://www.reddit.com/r/facebook/comments/1400000000000000000000000000000000000000/">show doing the above is generally ignored.</a> These posts do suggest that <a href="https://www.facebook.com/help/contact/copyrightform">facebook DCMA (Copyright) requests</a> are generally acted upon... funny that (and untrue in our experice - read on).   </p>

            <div style={{textAlign: "center",maxWidth:"1000px",width:"100%"}}>
            <GridItem xs={25} sm={25} md={25}>     
                  <img
                    src="/img/posts/2025-02-04-facebook-scams/facebook_dcma.png"
                    alt="Building a Streamlit application in 5 steps."
                    className={imgClasses}
                  />
                  <p><br></br><i>We tried the DCMS form above.. and were unsurprisingly unscuccessful. FB prefer "actual links to posts".</i></p>
            </GridItem>
            </div>

            <p> The above is of course part fo the everyday "fun" for users of big tech, FB in particular. A shockingly inadequate form, no phone number, no email address, no repsonibility, no method to overcome inevitable breaks in their system like above, no care given at all, just palpable dismissivenes.  </p>
            <p>Noone has a "beige" problem that fits these forms. Big tech, hell any tech, even no tech requires more than a bog standard form to explain even minor issues. The world is complex. FB is way more complex than anyone at FB cares to have responsibilty for. </p>
            <p> And of course promised for functionality - such as the huge technological leap of uploading a jpeg, no sorry a png,  ah screw it none of them work... er yeah they dont work, see above. </p>
            <p> Facebook has been disgraceful for us (and our clients) to deal with since day one. From simple support questions, questions to help clients who forgot their passowrds and fradulent activity, they have never ever once fixed the issues. Not once!</p>

            <p> Yet Facebook pours billions into legal defences, eg  <a href="https://www.oaic.gov.au/news/media-centre/landmark-settlement-of-$50m-from-meta-for-australian-users-impacted-by-cambridge-analytica-incident">$50million in 2024 in Australia</a> or <a href="https://www.zdnet.com/article/facebook-takes-3b-hit-from-ftc-investigation-in-q1/#google_vignette">$3BN set aside in 2019!</a>.</p> 
            <p>When a company is prepared to spend billions to fight against it's duty of care - can we expect anthing above a dismissive, inadequate, tiny, token gesture to fight small scale (but damaging to small business) fraud? What about fake news and rigging elections? Looks like thats back on the table now too. </p>

          
        



            <h3 className={classes.title} id="summary">Tribalism's response</h3>

            <p> The above doesnt greatly affect our business. Yes it wastes our time. Finding out where random  people approaching our business are even coming from is quite a job in itself! Yes it reduces our public image somewhat.</p>
            
            <p> Thankfully most people have been able to see this situation for what it is - rampant fraud which Facebook allows to happen. </p>

              <p> <strong>That said we would like to <i>empathise</i> with anyone who has inadvertantly applied to jobs from these fake ads either to our company or others caught up in this.</strong> </p>

              <p> We do not know anything about these, we do not have any control over them </p>

              <p> Please be very careful how you use all social media - especially facebook  and instagram. </p>

              <p> sincerely, the Tribalism Team </p>





              

</GridItem>





          

      </GridContainer>
    </div>
  );
}
